import React, { useState, useRef, PropsWithChildren, useImperativeHandle} from 'react';
import dxDataGrid from "devextreme/ui/data_grid";
import DropDownBox from 'devextreme-react/drop-down-box';
import DataGrid, {
    Column,
    Button,
    Editing,
    Selection, Paging, Scrolling,
} from 'devextreme-react/data-grid';
import TextBox from 'devextreme-react/text-box';
import RefUtils from '../utils/RefUtils';
//import CustomStore from 'devextreme/data/custom_store';
//import 'whatwg-fetch';

export interface IMyDropDownGridReportViewListOptions {
    dataSource: any;
    afterDelete?: any;
    onSelectedItemChange?: any;
    innerRef?: any;
    fieldIdName?: string;
    fieldTitleName?: string;
    placeholder?: string;
    editing?: boolean;
    deleting?: boolean;
    sortByName?: boolean;
    getTextBoxValueSetFunction?: any;
    dataColumns?: any[];
    conditionForItemDelete?: any;
//    defaultValue?: any;
}

const DropDownGridReportViewList: React.FC<PropsWithChildren<IMyDropDownGridReportViewListOptions>> = ({ dataSource, ...props }) => {

    const currFieldIdName = () => { return props.fieldIdName || 'id' };
    const currFieldTitleName = () => { return props.fieldTitleName || 'title' };
    const currPlaceholder = () => { return props.placeholder || "Построенные отчеты" };

    const defaultDataColumns = [
        {
            dataField: currFieldIdName(),
            visible: false,
            allowEditing: false,
            sortOrder: props.sortByName ? undefined : "desc",
            sortIndex: props.sortByName ? undefined : 0,
        },
        {
            dataField: currFieldTitleName(),
            visible: true,
            allowEditing: props.editing == true,
            sortOrder: props.sortByName ? "asc" : undefined,
            sortIndex: props.sortByName ? 0 : undefined,
        },
    ];

    const deleteButtonVisible = (e) => {
        if (e && e.row && e.row.data) {
            if (props.conditionForItemDelete) {
                const res = props.conditionForItemDelete(e.row.data);
                return res;
            }
        }
        return true;
    }
    const gridButtonsColumns = [
        {
            visible: props.deleting == true,
            width: 36,
            type: "buttons",
            buttons: [
                {
                    name: "delete",
                    icon: props.editing == true ? "trash" : "close",
                    hint: props.editing == true ? "Удалить" : "Закрыть",
                    visible: deleteButtonVisible,
                    /*
                                        onClick: (e) => {
                                            if (props.afterDelete) {
                                                props.afterDelete(e.row.data);
                                            }
                                        }
                    */
                },
            ],
        },
    ];

    const getDefaultColumns = () => {
        let res = (props.dataColumns || defaultDataColumns).concat(gridButtonsColumns);
        return res;
    }

//    let gridDataSource = dataSource;
    const gridDataSource = () => dataSource;
//    const defVal = props.defaultValue ? [props.defaultValue] : (currFieldIdName() == "Id" ? [] : [-1]);
//    const defVal = props.defaultValue ? [props.defaultValue] : [];
    const [gridBoxValue, setGridBoxValue] = useState([]);
    const [isGridBoxOpened, setIsGridBoxOpened] = useState(false);
    const textBoxRef = useRef(null);
    const dropDownBoxRef = props.innerRef || useRef(null);
    const dataGridRef = useRef(null);

    const getInstanceByRef = (aref) => {
        let current = aref.current;
        if (current) {
            let instance = current.instance;
            if (instance) {
                return instance;
            }
        }
        return null;
    }

    const doSelectedItemChange = (item) => {
        if (props.onSelectedItemChange) {
            props.onSelectedItemChange(item);
        }
    }
    const onRowClick = (e) => {
        setIsGridBoxOpened(false);
        doSelectedItemChange(e.data);
    }

    const currItem = (keyValue?) => {
        let item = gridDataSource().store()._array.find(item => item[currFieldIdName()] == (keyValue || gridBoxValue[0]
//            || props.defaultValue
        ));
        return item;
    }
    const selectedItemChange = (selectedKeys) => {
        setGridBoxValue(selectedKeys);
        //        dataGridInstance(dataGridRef).selectRows([selectedKeys], true);
        let item = currItem(selectedKeys);
        doSelectedItemChange(item);
    }

    const syncDataGridSelection = (e) => {
        selectedItemChange(e.value);
    }

    const dataGridOnSelectionChanged = (e) => {
        setIsGridBoxOpened(false);
        selectedItemChange(e.selectedRowKeys);
    }

    const gridBoxDisplayExpr = (item) => {
        return item && `${item[currFieldTitleName()]}`;
    }

    const onGridBoxOpened = (e) => {
        if (e.name === 'opened') {
            setIsGridBoxOpened(e.value);
        }
    }

    const onRowRemoved = (e) => {
        if (props.afterDelete) {
            props.afterDelete(e.data);
        }
    }

    const dataGridRender = () => {
        //console.log("dataGridRender.gridDataSource()");
        //console.log(gridDataSource());
        //console.log(["dataGridRender.dataGridRef", dataGridRef]);
        //const arr = gridDataSource.store()._array || [];
        //console.log(["gridDataSource.store()._array", arr]);
        return (
  //          <div style={{ height: 200, width: "100%", borderColor: "red" }}>
  //              <div>{"Какая-то неведомая хрень"}</div>
            <DataGrid
                ref={dataGridRef}
                showColumnHeaders={false}
                dataSource={gridDataSource()}
                //                defaultColumns={gridColumns}
                defaultColumns={getDefaultColumns()}
                hoverStateEnabled={true}
                selectedRowKeys={gridBoxValue}
                onSelectionChanged={dataGridOnSelectionChanged}
                onRowClick={onRowClick}
                height="100%"
                //height="200px"
//                height={300}

                focusedRowEnabled={true}
                autoNavigateToFocusedRow={true}
                onRowRemoved={onRowRemoved}
            >

                {true &&
                    <Editing
                        mode="row"
                        useIcons={false}
                        allowUpdating={false}
                        allowDeleting={true}
                        confirmDelete={false}
                    />
                }
                <Selection mode="single" />
                <Scrolling mode="virtual" />
                <Paging enabled={true} pageSize={10} />
                </DataGrid>
    //        </div>

        );
    }

    const onFieldClick = (e) => {
        if (props.editing == true) return;
        let item = currItem();
        if (item) {
            doSelectedItemChange(item);
        }
    }
    const fieldRender = value => {
        const item = currItem();
        //        const title = item ? item.title : "";
        const title = gridBoxDisplayExpr(item) || "";
        return (
            <div
                onClick={onFieldClick}
            >
                <TextBox
                    ref={textBoxRef}
                    defaultValue={title}
                    readOnly={props.editing !== true}
                    placeholder={currPlaceholder()}
                    hint={currPlaceholder()}
                />
            </div>
        );
    }

    const getTextBoxValue = () => {
        const res = textBoxRef.current.instance.option("value")
        //        let item = currItem();
        //        const res = gridBoxDisplayExpr(item);
        return res;
    }

    React.useEffect(() => {
        if (props.getTextBoxValueSetFunction) {
            props.getTextBoxValueSetFunction(() => {
                return getTextBoxValue;
            }
            );
        }
    }, []);

    return (
        <DropDownBox
            width="100%"
            ref={dropDownBoxRef}
            value={gridBoxValue}
            opened={isGridBoxOpened}
            //opened={ true}
            valueExpr={currFieldIdName()}
            deferRendering={false}
            displayExpr={gridBoxDisplayExpr}
            placeholder={currPlaceholder()}
            showClearButton={false}
            dataSource={gridDataSource()}
            onValueChanged={syncDataGridSelection}
            onOptionChanged={onGridBoxOpened}
            contentRender={dataGridRender}
            fieldRender={fieldRender}
            openOnFieldClick={false}
            hint={currPlaceholder()}
        />
    );
}



export default DropDownGridReportViewList;
